import { render, staticRenderFns } from "./PhotoTaken.vue?vue&type=template&id=cd6b1a1a&scoped=true&lang=pug&"
import script from "./PhotoTaken.vue?vue&type=script&lang=ts&"
export * from "./PhotoTaken.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoTaken.vue?vue&type=style&index=0&id=cd6b1a1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6b1a1a",
  null
  
)

component.options.__file = "PhotoTaken.vue"
export default component.exports